import Page from '../../../shared/components/Page/Page';
import {Button, Card, Col, Flex, Form, Input, message, Row} from "antd";
import GoogleAuthenticate from "../components/GoogleAuthenticate/GoogleAuthenticate";
import {useContext, useState} from "react";
import { updatePassword } from "../api";
import LoadingContext from "../../../app/contexts/LoadingContext";
function Security() {
    const [password,setPassword] = useState();
    const [newPassword,setNewPassword] = useState();
    const [reNewPassword,setReNewPassword] = useState();
    const [messageApi, contextHolder] = message.useMessage();
    const {setLoading} = useContext(LoadingContext);
    const handleUpdate = () => {
        if (!password) {
            messageApi.open({
                type: 'error',
                content: 'Vui lòng nhập mật khẩu hiện tại',
            });
            return;
        }
        if (!newPassword) {
            messageApi.open({
                type: 'error',
                content: 'Vui lòng nhập mật khẩu mới',
            });
            return;
        }
        if (!reNewPassword) {
            messageApi.open({
                type: 'error',
                content: 'Vui lòng xác nhận mật khẩu mới',
            });
            return;
        }
        if (newPassword !== reNewPassword) {
            messageApi.open({
                type: 'warning',
                content: 'Mật khẩu mới và mật khẩu xác nhận không trùng khớp vui lòng kiểm tra lại',
            });
            return;
        }
        const fetchData = async () => {
            setLoading(true);
            const response = await updatePassword(password,newPassword);
            if (!response.success) {
                messageApi.open({
                    type: 'error',
                    content: response.message
                });
            }
            else {
                messageApi.open({
                    type: 'success',
                    content: 'Cập nhật mật khẩu thành công'
                });
            }
            setLoading(false);
        }
        fetchData();
    }
    return (
        <Page title="Bảo mật">
            {contextHolder}
            <Row gutter={[16,16]}>
                <Col xs={24} sm={24} md={24} lg={16} xl={16}>
                    <Card title={'Đổi mật khẩu'}>
                        <Form layout="vertical">
                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                <Form.Item label={'Mật khẩu hiện tại'} name={'password'}>
                                    <Input.Password
                                        placeholder={'Nhập mật khẩu hiện tại'}
                                        onChange={(e) => setPassword(e.target.value)}
                                    />
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                <Form.Item label={'Mật khẩu mới'} name={'newPassword'}>
                                    <Input.Password
                                        placeholder={'Nhập mật khẩu mới'}
                                        onChange={(e) => setNewPassword(e.target.value)}
                                    />
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                <Form.Item label={'Xác nhận mật khẩu mới'} name={'reNewPassword'}>
                                    <Input.Password
                                        placeholder={'Nhập lại mật khẩu mới'}
                                        onChange={(e) => setReNewPassword(e.target.value)}
                                    />
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                <Flex justify={'end'}>
                                    <Button type={'primary'} onClick={handleUpdate}>Xác nhận</Button>
                                </Flex>
                            </Col>
                        </Form>
                    </Card>
                </Col>
                <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                    <Card title={'Cài đặt bảo mật'}>
                        <GoogleAuthenticate/>
                    </Card>
                </Col>
            </Row>
        </Page>
    )
}
export default Security;